import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useEffect, useState } from 'react';
import { obterConfiguracao } from '@/config/runtime';
import { useI18n } from '@/i18n/I18nProvider';
import { verificarSaude } from '@/services/geo-engine/requests';
import { useChamada } from '@/services/geo-engine/useChamada';
const TOM_POR_STATUS = {
    ok: 'ok',
    degradado: 'alerta',
};
/** Estado da conexão com a Geo-Engine: indicação discreta, sem detalhe técnico permanente. */
export function Saude() {
    const { environment } = obterConfiguracao();
    const { t } = useI18n();
    const { executar, carregando, erro } = useChamada();
    const [saude, setSaude] = useState(null);
    const consultar = useCallback(async () => {
        const resposta = await executar((sinal) => verificarSaude(sinal));
        if (resposta !== null) {
            setSaude(resposta);
        }
    }, [executar]);
    useEffect(() => {
        void consultar();
    }, [consultar]);
    const tom = erro !== null ? 'erro' : saude === null ? 'neutro' : TOM_POR_STATUS[saude.status];
    // A distinção importa: rede indisponível não é o mesmo que erro da aplicação.
    const rotulo = erro !== null
        ? erro.codigo === 'falha_de_rede'
            ? t('saude.inalcancavel')
            : t('saude.indisponivel')
        : saude === null
            ? carregando
                ? t('saude.verificando')
                : t('saude.conexao')
            : saude.status === 'ok'
                ? t('saude.conectado')
                : t('saude.degradado');
    const titulo = saude === null
        ? t('saude.tituloSemResposta', { ambiente: environment })
        : t('saude.titulo', { versao: saude.versao, banco: saude.banco, ambiente: environment });
    return (_jsxs("button", { type: "button", className: `sinal sinal--${tom}`, onClick: () => void consultar(), disabled: carregando, title: titulo, children: [_jsx("span", { className: "sinal__ponto", "aria-hidden": "true" }), rotulo] }));
}
